import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import MenuListItem from "../MenuListItem";

class MenuList extends Component {
  render() {
    const { t, style, loadSection, toggleMenu } = this.props;

    return (
      <div style={style}>
        <MenuListItem
          toggleMenu={toggleMenu}
          loadSection={loadSection}
          text={t("home")}
          name="WelcomeSection"
        />
        <MenuListItem
          toggleMenu={toggleMenu}
          loadSection={loadSection}
          text={t("lmc")}
          name="LmcSection"
        />
        <MenuListItem
          toggleMenu={toggleMenu}
          loadSection={loadSection}
          text={t("pixxer")}
          name="PixxerSection"
        />
        <MenuListItem
          toggleMenu={toggleMenu}
          loadSection={loadSection}
          text={t("skill")}
          name="SkillSection"
        />
        <MenuListItem
          toggleMenu={toggleMenu}
          loadSection={loadSection}
          text={t("WorkWithUs")}
          name="HiringSection"
        />
      </div>
    );
  }
}

export default withTranslation("menu")(MenuList);
